import { render, staticRenderFns } from "./chatMsg.vue?vue&type=template&id=256c57cc&scoped=true&"
var script = {}
import style0 from "./chatMsg.vue?vue&type=style&index=0&id=256c57cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c57cc",
  null
  
)

export default component.exports